<template>
    <div>
        <limitless-page-header
            title="Att göra"
            :sub-title="deliveryGroup"
        ></limitless-page-header>

        <div class="content">
            <div class="mb-3">
                <div class="btn-group">
                    <router-link
                        v-for="dg in deliveryGroups"
                        :key="'rl-' + dg"
                        :to="{ name: '', params: { deliveryGroup: dg } }"
                        class="btn"
                        :class="{ 'btn-light': deliveryGroup !== dg, 'btn-primary': deliveryGroup === dg }"
                    >{{ dg }}</router-link>
                </div>
                <button type="button" @click="reloadAll" class="ml-3 btn btn-light"><i :class="{'icon-reload-alt': all_types_loaded, 'icon-spinner2 spinner': !all_types_loaded}"></i></button>
            </div>
            <div v-if="all_types_loaded && num_todos <= 0 && !has_error">
                <div class="alert alert-info">Inget att göra 👍😄</div>
            </div>
            <div v-if="types && Object.keys(types).length > 0">
                <div v-for="(typeData, type) in types" :key="type">
                    <scanned-coupons-table
                        v-if="type === 'scanned_order_coupons'"
                        :ref="'table_' + type"
                        :title="typeData.title"
                        @loaded="setLoaded(type, $event)"
                    ></scanned-coupons-table>
                    <todo-table
                        v-else
                        :ref="'table_' + type"
                        :type="type"
                        :title="typeData.title"
                        :delivery-group="deliveryGroup"
                        @loaded="setLoaded(type, $event)"
                    ></todo-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import TodoTable from '@app/pages/prodorder/partials/TodoTable';
import ScannedCouponsTable from '@app/pages/prodorder/partials/ScannedCouponsTable';
import TodoTypeRepository from '@services/repositories/TodoTypeRepository';

export default {
    name: 'TodoList',
    components: {
        LimitlessPageHeader,
        TodoTable,
        ScannedCouponsTable,
    },
    props: {
        deliveryGroup: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        types: {},
        deliveryGroups: [
            'SE',
            'FI',
            'DE',
            'EU',
            'NO',
            'DK',
        ],
    }),
    mounted() {
        this.getAllTypes();
    },
    methods: {
        getAllTypes() {
            const repo = new TodoTypeRepository();
            repo.getAll().then((types) => {
                const typeObj = {};
                Object.keys(types).forEach((key) => {
                    typeObj[key] = {
                        title: types[key],
                        loaded: false,
                        num_todos: 0,
                    };
                });
                this.types = typeObj;
            });
        },
        setLoaded(type, value) {
            this.types[type].loaded = value.loaded;
            this.types[type].num_todos = value.num_todos;
            this.types[type].error = value.error;
        },
        reloadAll() {
            Object.keys(this.types).forEach((type) => {
                const key = 'table_' + type;
                if (this.$refs[key] && this.$refs[key][0]) {
                    this.$refs[key][0].getData();
                }
            });
        },
    },
    computed: {
        all_types_loaded() {
            const loaded = Object.values(this.types).find((t) => !t.loaded);
            return !(loaded);
        },
        has_error() {
            const error = Object.values(this.types).find((t) => !!(t.error));
            return !!(error);
        },
        num_todos() {
            let todos = 0;
            Object.values(this.types).forEach((type) => {
                todos += type.num_todos;
            });
            return todos;
        },
    },
};
</script>
